module.exports = __webpack_public_path__ + "img/operate1.890bb361.png";